import React, { Component } from 'react';

import {
    Box,
    Grid, Typography,
    Alert
} from  '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import InputText, { InputSelectNative } from '../../common/Form';
import Dialog from '../../common/Dialog';
// import { Alert } from '@mui/lab';
import Creatable from '../../common/Creatable';
import { PAGES } from './AccessTypeForm';

class UserForm extends Component {
    state = { 
        email: "",
        username: "",
        lastname: "",
        password: "",
        user_role: 1,
        confirm_password: "",

        user_employee_id: "",
        user_employee_idDisplay: {value:"", label:""},
        user_type: "",
        user_typeDisplay: {value:"", label:""},
        user_collab_account: "",
        user_super_email: "",

        errors:{
            email: "",
            username: "",
            lastname: "",
            password: "",
            user_role: "",
            confirm_password: "",
        }
    }
    // componentDidMount() {
    //     const employees = filter

    // }
    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        
        if(name === "password"){
            this.validPassword(value)
        }
        this.setState({
            [name]: value
        })
        
    }

    handleChangeEmployee = (option) => {
        if(option){
            this.setState({
                user_employee_id: option.value || "",
                user_employee_idDisplay: option
            })
        } else {
            this.setState({
                user_employee_id: "",
                user_employee_idDisplay: {}
            })

        }
    }
    handleChangeAccess = (option) => {
        if(option){
            this.setState({
                user_type: option.value || "",
                user_typeDisplay: option
            })
        } else {
            this.setState({
                user_type: "",
                user_typeDisplay: {}
            })

        }
    }

    validPassword = (password) => {
        let isValid = true
        let re = /[0-9]/;
        if(!re.test(password)) {
            isValid = false
        }
        re = /[a-z]/;
        if(!re.test(password)) {
            isValid = false
        }
        re = /[A-z]/;
        if(!re.test(password)) {
            isValid = false
        }
        if(password.length < 6){
            isValid = false
        }

        return isValid;
    }
    
    validate = () => {
        let required = [
            "email",
            "password",
            "confirm_password",
            "user_role",
            "username",
            "lastname",
        ]
        
        let noError = true
        let errors = {}

       
        required.map(field => {
            if(!this.state[field]){
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        if (this.state.password) {
            let isValid = this.validPassword(this.state.password);
            if (!isValid){
                errors.password =  "Le mot de passe doit contenir au minimum 6 caractères dont un chiffre, une majuscule et une minuscule"
                noError = false
            } else if (this.state.password !== this.state.confirm_password){
                errors.confirm_password =  "Le mot de passe et sa confirmation doivent être identiques"
                noError = false
            } else {
                errors.password = ""   
            }

        }
        this.setState({
            errors
        })
    
        return noError
    }
    handleSubmit = async () => {
        if(this.validate()){
            let data = {
                username : this.state.username.trim(),
                lastname : this.state.lastname.trim().toUpperCase(),
                email : this.state.email.trim(),
                user_password : this.state.password,
                user_role : parseInt(this.state.user_role) || 1,
                user_employee_id: this.state.user_employee_id,
                user_type: this.state.user_type,
                user_collab_account: this.state.user_collab_account,
                user_super_email: this.state.user_super_email.trim(),
            }
    
            console.log('====================================');
            console.log({data});
            console.log('====================================');
            
            await this.props.newUser(data)  
            if(this.props.STATE.users.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.users.error}`)
            } else{
                this.props.notif("success","Le compte a été créé avec succès")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs" )
        }
    }
    render() {
        const { EMPLOYEES, ACCESS } = this.props;
        return(
            <Dialog
                close={this.props.handleClose}
                fullWidth
                maxWidth="md"
                title="Créer un nouvel Utilisateur"
                submitAction={this.handleSubmit} 
                disabledSubmit={this.props.STATE.users.fetching}
                appBar
            >
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            required
                            name="email" 
                            id="email" 
                            value={this.state.email} 
                            label="Email de l'utilisateur" 
                            placeholder="Email" 
                            error={!!this.state.errors.email} 
                            helperText={this.state.errors.email} 
                            onChange={this.handleChange}/>
                        
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputSelectNative
                            error={this.state.errors.user_role}
                            label="Role"
                            onChange={this.handleChange}
                            value={this.state.user_role}
                            name="user_role" 
                            id="user_role" 
                            options={[
                                <option value={1} >USER</option>,
                                <option value={10} >USER +</option>,
                                <option value={2} >ADMIN</option>,
                                <option value={4} >ADMIN +</option>
                            ]}
                            labelWidth={40}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <InputText
                            required
                            name="username" 
                            id="username" 
                            value={this.state.username} 
                            label="Prénom" 
                            placeholder="Prénom de l'utilisateur" 
                            error={this.state.errors.username} 
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            required
                            name="lastname" 
                            id="lastname" 
                            value={this.state.lastname} 
                            label="Nom" 
                            placeholder="Nom de l'utilisateur" 
                            error={this.state.errors.lastname} 
                            onChange={this.handleChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <InputText
                            type="password"
                            required
                            name="password" 
                            id="password" 
                            value={this.state.password} 
                            label="Mot de passe" 
                            placeholder="Mot de passe de l'utilisateur" 
                            error={this.state.errors.password} 
                            onChange={this.handleChange}/>
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                        <InputText
                            type="password"
                            required
                            name="confirm_password" 
                            id="confirm_password" 
                            value={this.state.confirm_password} 
                            label="Confirmer le Mot de Passe" 
                            placeholder="Confirmer le Mot de Passe" 
                            error={this.state.errors.confirm_password} 
                            onChange={this.handleChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                            <Creatable
                                label="Compte Employé"
                                error={this.state.errors.user_employee_id}
                                id="user_employee_id"
                                options={Object.values(EMPLOYEES).map( item => ({
                                    label: `${item.employee_matricule} - ${item.employee_firstname} ${item.employee_lastname}`,
                                    value: item.employee_id
                                }))}
                                value={this.state.user_employee_idDisplay}
                                openPopUp={this.props.createNewEmployee}
                                onChange={this.handleChangeEmployee}
                                // {...this.props}
                            />
                        </Grid>
                        
                        <Grid item xs={12} sm={6}>
                            <Creatable
                                label="Type d'Accès"
                                error={this.state.errors.user_type}
                                id="user_type"
                                options={Object.values(ACCESS).map( item => ({
                                    label: item.access_name,
                                    value: item.access_id
                                }))}
                                value={this.state.user_typeDisplay}
                                onChange={this.handleChangeAccess}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                name="user_collab_account" 
                                id="user_collab_account" 
                                value={this.state.user_collab_account} 
                                label="Compte Collaborateur" 
                                placeholder="47.." 
                                error={this.state.errors.user_collab_account} 
                                helperText={this.state.errors.user_collab_account} 
                                onChange={this.handleChange}
                            />
                        </Grid>
                        {/* <Grid item xs={12} sm={6}>
                            <InputText
                                name="user_super_email" 
                                id="user_super_email" 
                                value={this.state.user_super_email} 
                                label="Super Email" 
                                placeholder="super.email@example.com" 
                                error={this.state.errors.user_super_email} 
                                helperText={this.state.errors.user_super_email} 
                                onChange={this.handleChange}
                            />
                        </Grid> */}
                        {this.state.user_type &&
                            <Grid item xs={12}>
                                <Alert severity="info">
                                    <Typography >L'utilisateur aura accès aux pages suivantes : </Typography>
                                    {ACCESS[this.state.user_type].access_pages.map( page => (
                                        <Box>
                                            <Typography variant="button" >{PAGES[page]}</Typography>
                                        </Box>
                                    ))}
                                </Alert>
                            </Grid>
                        }
                </Grid> 
            </Dialog>
        )

    }
}

export default UserForm;